module.exports = "e619cde3c52bcea99d25503cfa572758.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/bg5.png
// module id = 75
// module chunks = 0